import { render, staticRenderFns } from "./ProductContainer.vue?vue&type=template&id=783edd4f&scoped=true&"
import script from "./ProductContainer.vue?vue&type=script&lang=js&"
export * from "./ProductContainer.vue?vue&type=script&lang=js&"
import style0 from "./ProductContainer.vue?vue&type=style&index=0&id=783edd4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783edd4f",
  null
  
)

export default component.exports